/* External dependencies */
import { Anchor, Div, Text } from 'atomize';
import React from 'react';
import { Trans } from 'react-i18next';

export interface MeducationDownloadAppButton {
  icon?: React.ReactChild;
  id?: string;
  link?: string;
  store?: string;
  text?: string;
  className?: string;
}

export default function MeducationDownloadButton({
  icon,
  id,
  link,
  store,
  text,
  className,
}: MeducationDownloadAppButton) {
  return (
    <Anchor
      p={{ x: '1rem', y: { lg: '0.5rem' } }}
      bg="white"
      d="flex"
      justify="start"
      align="center"
      style={{ gap: '5px', borderRadius: '6px' }}
      textColor="inherit"
      target="_blank"
      href={link}
      hoverTextColor="inherit"
    >
      <Div maxW={{ xs: '30px', lg: '50px' }}>{icon}</Div>
      <Div>
        <Text
          textSize={{ xs: 'xs', lg: 'tiny' }}
          textColor="#000"
          textWeight="600"
          textTransform={id === 'googlePlayLink' && 'uppercase'}
          style={{ whiteSpace: 'nowrap' }}
        >
          <Trans>{text}</Trans>
        </Text>
        <Text
          textSize={{ xs: 'smallSize1', lg: 'smallSize2' }}
          textWeight="600"
          textColor="#000"
        >
          {store}
        </Text>
      </Div>
    </Anchor>
  );
}
